import React, { ReactElement } from "react";
import enumStrings, { RoutePaths } from "../../../enumStrings";
import ErrorBasePage from "./ErrorBasePage";

const Error404 = (): ReactElement => {
  const realRoutePaths = Object.values(RoutePaths);

  const actualRoutePath = window.location.pathname.toLowerCase();

  if (realRoutePaths.includes(actualRoutePath as RoutePaths)) {
    return <div />;
  }

  return (
    <ErrorBasePage
      title={enumStrings.pages.error404.title}
      subtitle={enumStrings.pages.error404.subtitle}
      description={enumStrings.pages.error404.description}
      emailSubject={enumStrings.pages.error404.emailSubject}
    />
  );
};

export default Error404;
